export default {
    computed: {
		userAgreementUrl() {
			return window.location.origin.replace("account.", "").concat("/user-agreement")
		},
	},
};